import { config as configureZod } from 'zod';

// zod decides whether it may compile object parsers by calling `new Function('')`
// when the first object schema is constructed. The browser apps ship a
// Content-Security-Policy without 'unsafe-eval', so the browser refuses that call
// and reports a CSP violation on every page load. `jitless` makes zod skip the
// probe. Under that policy zod already used its interpreted parser, so parsing
// results do not change.
//
// The setting only helps when it runs before the first object schema is
// constructed, so every browser entry imports this module first. It lives in
// `@crm/shared` on purpose: a build that moves the shared schema modules into a
// manual chunk evaluates that chunk before the entry chunk, and this module has to
// travel with them.
configureZod({ jitless: true });
